<div class="container-fluid">
    <div class="row">

      <div class="card shadow-sm p-0">
        <div class="card-header">
          <h3 class="card-title">{{ proposalStepId ? 'Update Proposal Step' : 'Create Proposal Step' }} </h3>
        </div>
        <div class="card-body">
          <settings-proposal-steps-form
            [proposalStep]="proposalStep"
          />
        </div>
      </div>
    </div>
    
  </div>
  